import React from 'react';
import styled from 'styled-components';

import { H1 } from './H1';

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1024px;
  width: 100%;
`;

const Panels = styled.div`
  display: grid;
  grid-gap: 22px;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;

  @media (max-width: 780px) {
    grid-template-columns: 1fr;
  }
`;

const TitleWrapper = styled.div`
  max-width: 500px;
  margin: 0 auto 30px;
`;

const Panel = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const PanelTitle = styled.h2`
  font-family: var(--secondary-font-family);
  font-size: 22px;
  margin: 0.5em 0 0;
`;

const Body = styled.p`
  font-family: var(--body-font-family);
  font-size: 15px;
  max-width: 270px;
`;

const Icon = styled.img`
  display: inline-block;
  font-size: ${p => p.size};
  margin-bottom: 0.25em;
  width: ${p => p.size};
`;

const DefaultIcon = styled.div`
  background: #e9e9e9;
  border-radius: ${p => p.size};
  display: inline-block;
  font-size: ${p => p.size};
  height: ${p => p.size};
  margin-bottom: 0.5em;
  width: ${p => p.size};
`;

// Some consumers base64 the content, others are PNGs.
const rudamentaryImageFormatCheck = (image, size) => {
  if (!image) {
    return <DefaultIcon size={size} />;
  }
  if (image.indexOf('data:image/svg+xml') > -1) {
    return <Icon src={image} size={size} />;
  }
  return <Icon src={image} size={size} />;
};

export const MarketingFeaturesList = ({
  title,
  sections = [],
  imgSize = '50px',
}) => {
  return (
    <Wrapper>
      {title && (
        <TitleWrapper>
          <H1 align="center">{title}</H1>
        </TitleWrapper>
      )}
      <Panels>
        {sections.map((section, index) => {
          const Image = rudamentaryImageFormatCheck(section.img, imgSize);
          return (
            <Panel key={index}>
              {Image}
              <PanelTitle>{section.title}</PanelTitle>
              <Body>{section.body}</Body>
            </Panel>
          );
        })}
      </Panels>
    </Wrapper>
  );
};
